import React, { createContext, useContext, useState } from 'react';
import { IProviderProps } from '../@types/ContextProviderRelated';

interface IValidationProviderContext {
  hasIntersectingWalls: boolean;
  setHasIntersectingWalls: React.Dispatch<React.SetStateAction<boolean>>;
}

export const ValidationContext = createContext<IValidationProviderContext | undefined>(undefined);

export const useValidation = () => {
  const context = useContext(ValidationContext);
  if (!context) {
    throw new Error('useValidation must be used within a ValidationProvider');
  }
  return context;
};

export const ValidationProvider = ({ children }: IProviderProps): JSX.Element => {
  const [hasIntersectingWalls, setHasIntersectingWalls] = useState<boolean>(false); // Boolean indicating that a wall is forming an intersecting shape

  const contextValue: IValidationProviderContext = {
    hasIntersectingWalls: hasIntersectingWalls,
    setHasIntersectingWalls: setHasIntersectingWalls,
  };
  return <ValidationContext.Provider value={contextValue}>{children}</ValidationContext.Provider>;
};
